import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { QuoteToolModes } from '@lx/quote-tool/shared/routing';
import { StepService } from '@lx/quote-tool/shared/services';
import { DOCUMENT } from '@angular/common';
import { GoogleAnalyticsService } from '@lx/shared/google-analytics';
import { PriceRequestFormGoogleAnalyticsEvent } from '../../../google-analytics';
import * as ElfsightEmbedSDK from '@elfsight/embed-sdk';
import { getConfiguration } from '@lx/shared/tokens';

@Component({
  selector: 'lx-confirmation-step',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  @ViewChild('whatsAppContainer', { static: true }) whatsAppContainer: ElementRef | undefined;
  title: string | undefined;
  lines: string[] = [];

  private readonly stepService = inject(StepService);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly document: Document = inject(DOCUMENT);
  private readonly configuration = getConfiguration();

  ngOnInit(): void {
    switch (this.stepService.getStoredMode()) {
      case QuoteToolModes.priceRequest:
        this.title = $localize`You've started your ESL journey!`;
        this.lines = [$localize`One of our advisors will respond to your enquiry as soon as possible, usually within 24 hours.`];

        // Track the confirmation event in Google Analytics
        this.googleAnalyticsService.trackViewEvent(PriceRequestFormGoogleAnalyticsEvent.QuoteLeadGen);
        break;
      case QuoteToolModes.form:
        this.title = $localize`Your trip is becoming a reality!`;
        this.lines = [
          $localize`We've sent a copy of your quote to your email address.`,
          $localize`Our team of advisors will be in touch soon to answer any questions you may have.`,
        ];
        break;
      case QuoteToolModes.enrollment:
        this.title = $localize`Your adventure has begun!`;
        this.lines = [
          $localize`We have received your request and one of our agents is checking the availability with the school. We will get back to you as soon as possible.`,
          $localize`If you have paid the deposit, our payment provider Flywire will send you a confirmation email.`,
          $localize`If you have urgent questions, you can also contact our advisors.`,
        ];
        break;
    }

    this.stepService.clearSessionStorage();
    this.loadElfSightWhatsAppWidget();
  }

  loadElfSightWhatsAppWidget() {
    const widgetID = this.configuration.ELFSIGHT_WHATSAPP_WIDGET as string;
    if (!this.whatsAppContainer || !ElfsightEmbedSDK || !widgetID) {
      return;
    }
    ElfsightEmbedSDK.displayWidget(this.whatsAppContainer.nativeElement, widgetID);
  }

  goToHomePage() {
    this.document.location.href = '/';
  }
}
